var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTemplateDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2V5H22V2.414L21.586 2H19V0H22L22.707 0.293L23.707 1.293L24 2ZM2 2.414L2.414 2H5V0H2L1.293 0.293L0.293 1.293L0 2V5H2V2.414ZM2 21.586V19H0V22L0.293 22.707L1.293 23.707L2 24H5V22H2.414L2 21.586ZM22 21.586L21.586 22H19V24H22L22.707 23.707L23.707 22.707L24 22V19H22V21.586ZM19 19L18 20H6L5 19V5L6 4H14L14.707 4.293L18.707 8.293L19 9V19ZM14 6.414V9H16.586L14 6.414ZM17 16V11H13L12 10V6H7V18H17V16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplateDocument);
export default __webpack_public_path__ + "static/1781163949/media/icon-template-document.eb4b13202b9ed08aa4096037b34e9236.svg";
export { ForwardRef as ReactComponent };